import EuroSymbolIcon from '@mui/icons-material/EuroSymbol';

import CompanyList from './CompanyList';
import CompanyCreate from './CompanyCreate';
import CompanyShow from './CompanyShow';
import CompanyEdit from './CompanyEdit';

const companies = {
	list: CompanyList,
	create: CompanyCreate,
	show: CompanyShow,
	edit: CompanyEdit,
	icon: EuroSymbolIcon
};

export default companies;
